<template>
<div>
 

    <vue-form @submit.prevent="login" name="forgetpasswordform" v-model="clientInfo" class=''>

        <div v-if="this.error" class='alert alert-danger'>
            {{ this.error }}
        </div>

        <div class="row">
            <vue-field class='col-12' type="string" ref="cpf" name="email" label="Email" required :validations="['email']"></vue-field>   
            <div class="col-12">
                 <input  class='btn btn-primary' type="submit" value="Entrar">
            </div>
        </div>
    </vue-form>
</div>
</template>

<script>

import validadeFormMixins from "@/mixins/validateForms"
import api from "@/api"

export default {

    mixins:[validadeFormMixins],
    data(){
        return{
            clientInfo:{},
            error:false,
            erromsg:'',
        }
    },

    watch:{
      
    },

    computed:{
        user:function(){
            return this.$store.getters.user
        }
    },

    methods:{

       
        login:async function(){
            this.$emit('loginStart', {cpf:this.clientInfo.cpf} )
            this.error = false;
            var formValid = await this.validateForms();
            if(!formValid) return
            let response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
            if(response.error){
                    this.error = "Dados inválidos" //response.data.error.message;
                    return false;
            }else{
                this.error = false;
                this.$emit('logged',this.user)
                return true;
            }
        },
        

        formsOk: async function(){

            let response;

            if(this.user && this.edit == false){
                //update user
                return true
            }
            
            if(this.user && this.edit){
                this.error = false
                //try to relogin
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
                 if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }

                //if ok, save data
                response = await this.$store.dispatch('updateUser', this.clientInfo )
                 if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }
                 return true;
            }
            
            if(this.userWithDataExist){
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
            
            }else{
                var formValid = await this.validateForms();
                if(formValid){
                    if(this.userWithDataExist){
                        
                    }else{
                        response = await this.$store.dispatch('register', this.clientInfo )
                    }
                }else{
                    return false
                }
            }

            if(response.error){
                    this.error = response.data.error.message;
                    return false;
            }else{
                return true;
            }

        }
    }

}
</script>

<style>

</style>
